const fristerRouter = {
    //更改权限格式
    change(router) {
        let routerArr = JSON.parse(localStorage.getItem('menu'))
        if (routerArr.length > 0) {
            routerArr = routerArr[0].childs
        }

        //获取登录用户的id
        setTimeout(() => {
            routerArr.forEach(item => {
                const allRouter = router.getRoutes()
                let flag = allRouter.some(i => i.path == item.path)
                if (!flag) {
                    const obj = {
                        name: item.dxtxSystemMenuUrl,
                        path: '/' + item.dxtxSystemMenuUrl,
                        meta: {
                            title: item.dxtxSystemMenuName
                        }
                    }
                    //把路由对象添加到首页的children中
                    router.addRoute("root", obj)
                    if (item.childs && item.childs.length > 0) {
                        item.childs.forEach(child => {
                            const allRouter2 = router.getRoutes()
                            let flag2 = allRouter2.some(i2 => i2.path == child.path)
                            if (!flag2) {
                                const obj2 = {
                                    name: child.dxtxSystemMenuUrl,
                                    path: obj.path + '/' + child.dxtxSystemMenuUrl,
                                    meta: {
                                        title: child.dxtxSystemMenuName,
                                        titleArr: [item.dxtxSystemMenuName, child.dxtxSystemMenuName]
                                    },
                                    component: () => import("@/views/DXTXBRANCH" + child.dxtxSystemMenuUrl + '.vue'),
                                }
                                if(item.childs.length == 1){
                                    obj2.meta.titleArr = [item.dxtxSystemMenuName]
                                }
                                //把路由对象添加到首页的children中
                                router.addRoute("root", obj2)
                            }
                        })
                    }
                }
            })
        }, 200);
    }
}
export default fristerRouter